// extracted by mini-css-extract-plugin
module.exports = {"details__content":"ListingDetails_details__content__2NzUk"};